import { Component, OnInit } from '@angular/core';
import { OnBehalfFlowComponent } from "../on-behalf-flow.component";
import { SubHeader } from "../../../../core/models/sub-header.model";
import { StateType } from "../../../../common/models/flow.dto";
import { FlowButtonOverrideService } from "../../../services/flow-button-override.service";
import { Button } from "../../../models/flow.model";


@Component({
    selector: 'read-only-on-behalf',
    templateUrl: '../on-behalf-flow.component.html',
    styleUrls: ['../../flow/flow.component.scss'],
    providers: [FlowButtonOverrideService],
    standalone: false
})
export class ReadOnlyOnBehalfComponent extends OnBehalfFlowComponent implements OnInit {

    get isReadOnly(): boolean {
        return true;
    }

    ngOnInit() {
        this.onFormGenerated.subscribe(() => {
            for (let questionGroup of this.page.questions) {
                questionGroup.forEach(x => {
                    (x.enabled as any) = () => { return false; };
                });
            }
        });
        super.ngOnInit();
    }

    isButtonDisabled(button: Button): boolean {
        return !button.isNavigation || button.isTransition;
    }

    setContextEjected(ejected: Date | string): void {
        return;
    }

    setSubheader(): SubHeader {
        let buttons = [];
        const viewNotesButtonTitle = (this.state.stateType === StateType.InputForm ? "View Notes" : "View Notes & Timeline");
        const viewNotesButton = { name: viewNotesButtonTitle, method: () => this.addFlowNote() };
        if (this.workflow.currentWorkItem) {
            buttons.push(viewNotesButton);
        }
        const ejectButton = {
            name: "Eject", method: () => {
                return;
            }         
        };
        buttons.push(ejectButton);
        return new SubHeader({ title: this.title, buttons: buttons })
    }


}
